import { SignUp } from "@clerk/nextjs";

export function CreateReboltAccountStep() {
  return (
    <div className="h-full flex flex-col justify-start lg:justify-center px-5 lg:px-40 py-6 lg:py-0 w-full">
      <SignUp routing="hash" signInUrl="/sign-in" />
    </div>
  );
}
